import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import AiAgentAPI from '../../api/aiAgents';

export const state = {
  records: [],
  recordsAll: [],
  typeBot:{},
  totalCount:0,
  published: false,
  currentAgent: null,
  uiFlags: {
    isFetching: false,
    isFetchingAll: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isUploadingFile: false,
    isErrorUpload: null,
    isApiKeyError: true,
  },
};

export const getters = {
  getAiAgents($state) {
    return $state.records;
  },
  getAllAiAgents($state) {
    return $state.recordsAll;
  },

  getTotalCount($state){
    return $state.totalCount;
  },
  getVerifiedAiAgents($state) {
    return $state.records.filter(record => record.confirmed);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },

  getAiAgentStatus($state) {
    let status = {
      online: $state.records.filter(
        aiAgent => aiAgent.availability_status === 'online'
      ).length,
      busy: $state.records.filter(aiAgent => aiAgent.availability_status === 'busy')
        .length,
      offline: $state.records.filter(
        aiAgent => aiAgent.availability_status === 'offline'
      ).length,
    };
    return status;
  },
  getTypeBotData($state){
    return $state.typeBot;
  },
  getCurrentAgent: state => state.currentAgent
};

export const actions = {
  get: async ({ commit },params) => {
    commit(types.default.SET_AIAGENT_FETCHING_STATUS, true);
    try {
      const response = await AiAgentAPI.get(params);
      commit(types.default.SET_AIAGENT_FETCHING_STATUS, false);
      commit(types.default.SET_AIAGENTS, response.data);
      commit("setTotalCount",response.headers["count"] )
    } catch (error) {
      commit(types.default.SET_AIAGENT_FETCHING_STATUS, false);
    }
  },
  getAll: async ({ commit },params) => {
    commit(types.default.SET_AIAGENT_ALL_FETCHING_STATUS, true);
    try {
      const response = await AiAgentAPI.getAll(params);
      commit(types.default.SET_AIAGENT_ALL_FETCHING_STATUS, false);
      commit("setAllAiAgents", response.data);
      
    } catch (error) {
      commit(types.default.SET_AIAGENT_ALL_FETCHING_STATUS, false);
    }
  },
  createAIAgent: async ({ commit }, aiAgentInfo) => {
    commit(types.default.SET_AIAGENT_CREATING_STATUS, true);
    try {
      const response = await AiAgentAPI.createAgent(aiAgentInfo);
      commit(types.default.ADD_AIAGENT, response.data);
      commit(types.default.SET_AIAGENT_CREATING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_AIAGENT_CREATING_STATUS, false);
      throw error;
    }
  },

  updateAIAgent: async ({ commit }, aiAgentInfo) => {
    commit(types.default.SET_AIAGENT_UPDATING_STATUS, true);
    try {
      const response = await AiAgentAPI.updateAgent(aiAgentInfo);
      commit(types.default.ADD_AIAGENT, response.data);
      commit(types.default.SET_AIAGENT_UPDATING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_AIAGENT_UPDATING_STATUS, false);
      throw error;
    }
  },
  update: async ({ commit }, { id, ...aiAgentParams }) => {
    commit(types.default.SET_AIAGENT_UPDATING_STATUS, true);
    try {
      const response = await AiAgentAPI.update(id, aiAgentParams);
      commit(types.default.EDIT_AIAGENT, response.data);
      commit(types.default.SET_AIAGENT_UPDATING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_AIAGENT_UPDATING_STATUS, false);
      throw new Error(error);
    }
  },
  updateSingleAiAgentPresence: ({ commit }, { id, availabilityStatus }) => {
    commit(types.default.UPDATE_SINGLE_AIAGENT_PRESENCE, {
      id,
      availabilityStatus,
    });
  },
  updatePresence: async ({ commit }, data) => {
    commit(types.default.UPDATE_AIAGENTS_PRESENCE, data);
  },
  deleteAgent: async ({ commit }, aiAgentId) => {
    commit(types.default.SET_AIAGENT_DELETING_STATUS, true);
    try {
      await AiAgentAPI.deleteAgent(aiAgentId);
      commit(types.default.DELETE_AIAGENT, aiAgentId);
      commit(types.default.SET_AIAGENT_DELETING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_AIAGENT_DELETING_STATUS, false);
      throw new Error(error);
    }
  },
  getTypoBot:async ({ commit }) => {
    commit(types.default.SET_AIAGENT_FETCHING_STATUS, true);
    try {
      const response = await AiAgentAPI.getTypeBotToken();
      commit(types.default.SET_AIAGENT_FETCHING_STATUS, false);
      commit('setTypoBotToken', response.data);
    } catch (error) {
      commit(types.default.SET_AIAGENT_FETCHING_STATUS, false);
    }
  },
  publish:async ({ commit }, aiAgentId) => {
    commit(types.default.SET_AIAGENT_UPDATING_STATUS, true);
    try {
      const response = await AiAgentAPI.publish(aiAgentId);
      commit(types.default.SET_AIAGENT_UPDATING_STATUS, false);
      commit('publishAiAgent', response.data);
    } catch (error) {
      commit(types.default.SET_AIAGENT_UPDATING_STATUS, false);
    }
  },
  uploadAgentFile: async function uploadFileAiAgent({ commit }, file) {
    
    console.log("asdadasdsadasdasdasdasdasda carga de archivo");
    commit(types.default.SET_AIAGENT_UI_FLAG, { isUploadingFile: true, isErrorUpload:null });
    //commit('setFileID', null);
    //commit('setFileName', "");
    
    try {

      console.log("file", file);

      let formData = new FormData();
      formData.append('file', file);

      const response = await AiAgentAPI.uploadFile(formData);
      
      commit(types.default.SET_AIAGENT_UI_FLAG, { isUploadingFile: false, isErrorUpload:false });
      //commit("setFileTemplateData",{ fileName: file.name, data: response.data});
      return response;
      
    } catch (error) {

      console.log("error", error);
      
      commit(types.default.SET_AIAGENT_UI_FLAG, { isUploadingFile: false, isErrorUpload:true });
    } finally {
      commit(types.default.SET_AIAGENT_UI_FLAG, { isUploadingFile: false });
    }
  },
  fetchAgent: async ({ commit }, agentId) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await AiAgentAPI.fetchAgent(agentId);
      commit('SET_CURRENT_AGENT', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching agent:', error);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  }
};


export const mutations = {
  [types.default.SET_AIAGENT_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  setTypoBotToken($state, data){
    $state.typeBot = data
  }, 

  publishAiAgent($state, data){
    $state.published = true
  }, 

  setTotalCount($state, count)
  {
    if(count){
    $state.totalCount = parseInt(count)
    }else{
      $state.totalCount=0
    }
  }, 

  setAllAiAgents($state, data){
    $state.recordsAll = data;
  },

  [types.default.SET_AIAGENT_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetching = status;
  },
  [types.default.SET_AIAGENT_ALL_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetchingAll = status;
  },
  [types.default.SET_AIAGENT_CREATING_STATUS]($state, status) {
    $state.uiFlags.isCreating = status;
  },
  [types.default.SET_AIAGENT_UPDATING_STATUS]($state, status) {
    $state.uiFlags.isUpdating = status;
  },
  [types.default.SET_AIAGENT_DELETING_STATUS]($state, status) {
    $state.uiFlags.isDeleting = status;
  },

  [types.default.SET_AIAGENTS]: MutationHelpers.set,
  [types.default.SET_ALL_AIAGENTS]: MutationHelpers.set,
  [types.default.ADD_AIAGENT]: MutationHelpers.create,
  [types.default.EDIT_AIAGENT]: MutationHelpers.update,
  [types.default.DELETE_AIAGENT]: MutationHelpers.destroy,
  [types.default.UPDATE_AIAGENTS_PRESENCE]: MutationHelpers.updatePresence,
  [types.default.UPDATE_SINGLE_AIAGENT_PRESENCE]: (
    $state,
    { id, availabilityStatus }
  ) =>
    MutationHelpers.updateSingleRecordPresence($state.records, {
      id,
      availabilityStatus,
    }),
  SET_CURRENT_AGENT(state, agent) {
    state.currentAgent = agent;
  },
  SET_UI_FLAG(state, { key, value }) {
    if (typeof key === 'object') {
      Object.assign(state.uiFlags, key);
    } else {
      state.uiFlags[key] = value;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
